module.exports = __webpack_public_path__ + "static/media/icon-daily.a36ddba5.svg";